import React from 'react';

import { Button } from '@/components/atoms';

import { TabItemProps } from './types';

const TabItem: React.FC<TabItemProps> = ({
  icon,
  label,
  isActive,
  onClick,
}) => (
  <Button
    className={`
      flex flex-col items-center gap-2
      rounded-(--library-filter-radius)
      px-[var(--library-filter-hspacing)]
      py-[var(--library-filter-vspacing)]
      shadow-md
      hover:shadow-lg hover:cursor-pointer
      my-4
    `}
    variant={isActive ? 'primary' : 'secondary'}
    onClick={onClick}
  >
    {icon}
    {label}
  </Button>
);

export default TabItem;
